<div class="col-sm">
  <p-panel header="Filter" data-tone="surface">
    <ng-template pTemplate="icons">
      <p-button
        icon="pi pi-th-large"
        [severity]="displayMode === 'grouped' ? 'primary' : 'secondary'"
        pTooltip="{{ 'productionCardViewer.gridView' | translateWF: 'Grid View' }}"
        tooltipPosition="top"
        (onClick)="displayMode = 'grouped'"
      />
      <p-button
        icon="pi pi-list"
        [severity]="displayMode === 'flat' ? 'primary' : 'secondary'"
        pTooltip="{{ 'productionCardViewer.listView' | translateWF: 'List View' }}"
        tooltipPosition="top"
        (onClick)="displayMode = 'flat'"
      />
    </ng-template>

    <p-card data-variant="flat">
      <div class="grid-auto-3">
        <div class="form-box">
          <p-select [options]="filterAddition" [placeholder]="'Select' | translateWF: 'Select'" [formControl]="filterAdditionSelected" class="w-full" />
        </div>
        <div class="form-box">
          <p-multiselect [options]="filterStatus" [placeholder]="'Status' | translateWF: 'Status'" [formControl]="filterStatusSelected" [maxSelectedLabels]="3" class="w-full" />
        </div>
        <div class="form-box">
          <p-select [options]="filterLoopLengthOptions" [placeholder]="'LoopLength' | translateWF: 'LoopLength'" [formControl]="filterLoopLengthSelected" class="w-full" />
        </div>
      </div>
    </p-card>
  </p-panel>

  @if (displayMode === 'grouped') {
    <p-card>
      <div [ngClass]="{ 'list-overflow': hasOverflow }" class="list-production-cards">
        @if (filteredProductionCards.length > 0) {
          @for (control of filteredProductionCards; track $index) {
            <app-production-card
              [assets]="allAssets"
              [colors]="allColors"
              [productionCardFormGroup]="control"
              [tags]="tags"
              [workOrder]="workOrder!"
              [readonly]="isProductionCardReadonly(control)"
              [isForSelection]="isForSelection"
              [showAssignRollButton]="showAssignRollButton"
              [filterStatusOptions]="true"
              [selectedCard]="isForSelection ? verifyIfProductionCardIsSelected(control) : false"
              (productionCardSelected)="onProductionCardSelected(true, $event)"
              (productionCardUnselected)="onProductionCardSelected(false, $event)"
              (navigateToProductionCardDetails)="navigateToProductionCard($event)"
            />
          }
        } @else {
          <p-card>
            <p>
              <b>
                {{ 'productionCardViewer.emptyProductionCards' | translateWF: 'No Production cards added' }}
              </b>
            </p>
          </p-card>
        }
      </div>
    </p-card>
  } @else {
    <p-card data-variant="compact">
      <p-table dataKey="value.id" [value]="filteredProductionCards" [expandedRowKeys]="expandedRows">
        <ng-template pTemplate="header">
          <tr class="primary__header">
            @if (isForSelection) {
              <th style="width: 5rem"></th>
            }
            <th style="width: 5rem"></th>
            <th>
              {{ 'productionCardViewer.pcNumber' | translateWF: 'PC Number' }}
            </th>
            <th>
              {{ 'productionCardViewer.color' | translateWF: 'Color' }}
            </th>
            <th>
              {{ 'productionCardViewer.dyeingMachine' | translateWF: 'Dyeing Machine' }}
            </th>
            <th>
              {{ 'productionCardViewer.status' | translateWF: 'Status' }}
            </th>
            <th>
              {{ 'productionCardViewer.totalQty' | translateWF: 'Total Qty' }}
            </th>
            @if (!isForSelection) {
              <th>
                {{ 'productionCardViewer.batchingEstimatedDate' | translateWF: 'Batching Estimated Date' }}
              </th>
              <th>
                {{ 'productionCardViewer.finishingEstimatedDate' | translateWF: 'Finishing Estimated Date' }}
              </th>
            }
            <th>
              {{ 'productionCardViewer.tags' | translateWF: 'Tags' }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pc let-expanded="expanded">
          <tr [class.row-expanded]="expanded">
            @if (isForSelection) {
              <td>
                @if (canEditProductionCard(pc)) {
                  @if (verifyIfProductionCardIsSelected(pc)) {
                    <p-button icon="pi pi-check" [rounded]="true" (click)="onProductionCardSelected(false, pc)" />
                  } @else {
                    <p-button icon="pi pi-plus" [outlined]="true" [rounded]="true" (click)="onProductionCardSelected(true, pc)" />
                  }
                }
              </td>
            }
            <td>
              <p-button type="button" pRipple [pRowToggler]="pc" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
            </td>
            <td class="truncate">
              <a (click)="navigateToProductionCard(pc.value.productionCardNumber)">{{ pc.value.productionCardNumber }}</a>
            </td>
            <td class="truncate">
              {{ pc.value.color?.name || pc.value.colorName }}
            </td>
            <td>
              {{ pc.value.dyeingAsset?.assetId }}
            </td>
            <td>
              <app-view-status [currentStatus]="pc.value.status ?? 0" />
            </td>
            <td>
              {{ productionCardTotalQty(pc) | number: '1.2-2' }}
            </td>
            @if (!isForSelection) {
              <td>{{ pc.value.batchingEstimatedDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ pc.value.finishingEstimatedEndDate | date: 'dd/MM/yyyy' }}</td>
            }
            <td>
              <div class="flex items-center gap-2 flex-wrap">
                <div class="tags-container">
                  <ng-container>
                    <span *ngFor="let tag of pc.value.tags ?? []" class="tag">
                      {{ tag.name }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <!-- Level 2: productionCardEntries -->
        <ng-template #expandedrow let-pc>
          <tr>
            <td colspan="9" class="!py-0 !px-0 !border-none">
              <p-table [value]="pc.value.productionCardEntries">
                <ng-template #body let-entry let-expanded="expanded">
                  <tr>
                    <td style="width: 6rem"></td>
                    <td style="width: 160px">{{ entry.fabricCode }}</td>
                    <td>{{ getFabricLongDescription(entry.fabricCode) }}</td>
                    <td style="width: 160px">
                      {{ 'LoopLength' | translateWF: 'Loop Length' }}:<br />
                      {{ getTotalLoopLengthByFabricCode(entry.fabricCode) | json }}
                    </td>
                    <td style="width: 160px">{{ entry.quantity | number: '1.2-2' }}</td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td style="width: 5rem"></td>
                    <td colspan="6" class="font-semibold">
                      {{
                        'productionCardViewer.noEntriesProductionCard'
                          | translateWF
                            : 'There are no entries for this production
            card yet.'
                      }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</div>
